module.exports = __webpack_public_path__ + "img/classes_icon_pink.2257abe3.svg";